import { render, staticRenderFns } from "./NewInsurancePolicy.vue?vue&type=template&id=6f77c9ad&scoped=true&"
import script from "./NewInsurancePolicy.vue?vue&type=script&lang=js&"
export * from "./NewInsurancePolicy.vue?vue&type=script&lang=js&"
import style0 from "./NewInsurancePolicy.vue?vue&type=style&index=0&id=6f77c9ad&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f77c9ad",
  null
  
)

export default component.exports